// @flow
// $FlowFixMe: useState exists
import React, {useState} from 'react';
import styled from 'styled-components';

const StyledTermLinkContainer = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  && p {
    font-size: 1.25rem;
  }
`;

const TermsLinkText = styled.a`
  && {
    display: block;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
    
    :hover {
      color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
      text-decoration: underline;
    }
  }`
;

const TermsPageLink = (props) => {
  const {onceClicked} = props;

  return (
      <StyledTermLinkContainer onClick={onceClicked}>
        <p> Please read the terms and conditions article in the link below to begin using the platform </p>
        <TermsLinkText href='https://www.trustar.co/terms-of-use' target={'_blank'}> Terms of Use Document </TermsLinkText>
      </StyledTermLinkContainer>
  )
};

export const TermsOfUseLink = (props: Object) => {
  const {clickedOnTermsUrl} = props;

  return <TermsPageLink onceClicked={clickedOnTermsUrl}/>

}



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Eula/EulaArticle.js